<template>
  <div class="hideable-paragraph">
    <div
      class="switch d-flex flex-row justify-content-between align-items-center cursor-pointer"
      @click="switchTextVisibility"
    >
      <h3 class="switch__header">{{ title }}</h3>
      <div v-if="isHideable">
        <SwitchIcon :is-active="isTextVisible"></SwitchIcon>
      </div>
    </div>
    <p
      v-if="!isHideable || (isTextVisible && text)"
      class="text"
      v-html="text"
    ></p>
    <slot v-if="!isHideable || (isTextVisible && text)"></slot>
  </div>
</template>

<script>
import SwitchIcon from '../Elements/SwitchIcon';

export default {
  name: 'HideableParagraph',
  components: {
    SwitchIcon
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    isHideable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isTextVisible: false
    };
  },

  methods: {
    switchTextVisibility() {
      if (!this.isHideable) return;
      this.isTextVisible = !this.isTextVisible;
    }
  }
};
</script>

<style lang="scss" scoped>
.hideable-paragraph {
  padding: 10px 0px;

  .switch {
    user-select: none;

    &__header {
      font-size: 20px;
      line-height: 26px;
      font-weight: $font-weight-demi-bold;
    }
  }

  .text {
    white-space: pre-line;
    word-wrap: break-word;
    font-size: 16px;
    line-height: 22px;
    font-weight: $font-weight-regular;
    margin-right: 8px;
  }
}
</style>
